<div class="location-route">
  <!-- <loading class="loading" [isAbsolute]="false" [isLoading]="routeSheetService.isLoadingList"></loading> -->
  <!-- buscador y filtro -->
   <!-- *ngIf="!includeRoute" -->
    <div class="filter-section">
      <div class="searchBar-flex" >
        <div class="searchBar" id="searchLocationInput">
          <mat-form-field class="width-input">
            <input
              #filterGlobal
              [(ngModel)]="globalFinder"
              matInput
              placeholder="Buscar por identificador"
              spellcheck="false"
              type="text"
              (input)="filter(filterGlobal.value)"
            />
          </mat-form-field>
        </div>
        <div class="btnSearch-container" (click)="filter(filterGlobal.value)">
          <img class="btnSearchIcon" src="/assets/img/icon_search.png">
        </div>
      </div>

      <div *ngIf="this.locationCategory && this.locationCategory.name == 'Services' " class="icon-group">
        <div [matMenuTriggerFor]="orderMenu" matTooltip="Ordenar Por">
          <div class="menu-button" mat-icon-button>
            <mat-icon>swap_vert</mat-icon>
          </div>
        </div>
        <mat-menu #orderMenu="matMenu">
          <button mat-menu-item (click)="setOrder(false)">
            <span [ngClass]="{'selected': !isRouteOrderFilterValue}" style="font-size: small !important;">Por vencimiento (default)</span>
          </button>
          <button mat-menu-item (click)="setOrder(true)">
            <span [ngClass]="{'selected': isRouteOrderFilterValue}" style="font-size: small !important;">Distancia más corta</span>
          </button>
        </mat-menu>
      </div>

      <div class="icon-group">
        <div style="cursor:pointer;" matTooltip="Refrescar">
          <div class="menu-button" mat-icon-button (click)="forceReload()">
            <mat-icon>refresh</mat-icon>
          </div>
        </div>
      </div>
    </div>
  

  <div class="cache-warning-banner" *ngIf="showCacheWarning">
    Datos cargados desde caché, posible desfase
  </div>

  <!-- <div class="button-list" *ngIf="includeRoute">
   <div mat-button class="btn-refresh" (click)="refreshRelatedList()" matTooltip="Reestablecer">
      <mat-icon>refresh</mat-icon>
    </div>
    <div mat-button class="btn-update" (click)="updateRelatedList()" matTooltip="Actualizar">
      <mat-icon>save_alt</mat-icon>
    </div>
  </div> -->

  <!-- cartas -->  <!-- cdkDrag  cdkDropList (cdkDropListDropped)="drop($event)" -->
  <div class="cards-container">

    <!-- routesheet clasico: card fija segun la categoria -->
    <ng-container *ngIf="!isDynamicRouteSheet()">
      <div class="row" *ngFor="let item of shownLocationRouteSheetList">

        <route-sheet-services-card *ngIf="this.locationCategory.name == 'Services'" [routeSheetLocation]="item" [skeletonLoading]="false" (click)="clickLocation(item)">
        </route-sheet-services-card>

        <route-sheet-unit-card *ngIf="this.locationCategory.name == 'Unit'" [routeSheetLocation]="item" [skeletonLoading]="false" (click)="clickLocation(item)">
        </route-sheet-unit-card>

        <route-sheet-generic-card *ngIf="this.locationCategory.name != 'Services' && this.locationCategory.name != 'Unit'" [routeSheetLocation]="item" [skeletonLoading]="false" (click)="clickLocation(item)">
        </route-sheet-generic-card>

      </div>
    </ng-container>

    <!-- routesheet dinamico: la card se arma con los datos que traiga cada item -->
    <ng-container *ngIf="isDynamicRouteSheet()">
      <div class="row" *ngFor="let card of dynamicCards">

        <route-sheet-dynamic-card
          [title]="card.title"
          [key]="card.key"
          [subtitle]="card.subtitle"
          [status]="card.status"
          [fields]="card.fields"
          [skeletonLoading]="false"
          (click)="clickLocation(card.source)">
        </route-sheet-dynamic-card>

      </div>
    </ng-container>

    <div class="row location-route-data" *ngIf="!hasItems && this.locationRouteSheetListResponse != ''">
      <div >
        <h3>{{ this.locationRouteSheetListResponse}}</h3>
      </div>
    </div>

    <ng-container *ngIf="!hasItems && this.locationRouteSheetListResponse == ''">
      <div class="row" *ngFor="let skel of [1]">
        <route-sheet-services-card [skeletonLoading]="true"></route-sheet-services-card>
      </div>
    </ng-container>
  </div>
  
</div>